import React from "react"
import { Helmet } from "react-helmet"

const Seo = ({title, metaDescription, imageUrl, url}) => {
  return(
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="viewport" content="width=device-width, initial-scale = 1.0, maximum-scale=1.0, user-scalable=no" /> 
      <title>
        {title ?? "Atlas One - The all-in-one digital citizen engagement platform"}
      </title>
      <meta
        name="description"
        content={
          metaDescription ?? "Atlas One consists of a suite of modern public safety and government communication tools, providing everything your organization needs to effectively communicate with your residents."
        }
      >
      </meta>

      <meta property="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@atlasoneapp" />
      <meta name="twitter:creator" content="@atlasoneapp" />
      <meta name="twitter:app:country" content="US" />
      <meta name="twitter:app:name:iphone" content="Atlas One" />
      <meta name="twitter:app:id:iphone" content="1509528933" />
      <meta name="twitter:app:name:googleplay" content="Atlas One" />
      <meta name="twitter:app:id:googleplay" content="app.atlasone" />

      <meta property="og:site_name" content="Atlas One"/>
      <meta property="og:type" content="article" />

      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {title && <meta property="og:title" content={title} />}
      {metaDescription && <meta property="og:description" content={metaDescription}  />}
      {url && <meta property="og:url" content={url} />}

      <meta property="og:locale" content="en_US" />
      <link data-n-head="ssr" rel="icon" type="image/x-icon" href="/images/favicon.ico?v=M44lzPylqQ"></link>
      <link 
        rel="apple-touch-icon" 
        sizes="180x180" 
        href="/images/apple-touch-icon.png"
      />
      <link 
        rel="icon" 
        type="image/png" 
        sizes="16x16" 
        href="/images/Favicon_16x16.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="24x24" 
        href="/images/Favicon_24x24.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="32x32" 
        href="/images/Favicon_32x32.svg"
      />
      <link 
        rel="icon" 
        type="image/png" 
        sizes="48x48" 
        href="/images/Favicon_48x48.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="57x57" 
        href="/images/Favicon_57x57.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="60x60" 
        href="/images/Favicon_60x60.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="64x64" 
        href="/images/Favicon_64x64.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="70x70" 
        href="/images/Favicon_70x70.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="76x76" 
        href="/images/Favicon_76x76.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="96x96" 
        href="/images/Favicon_96x96.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="114x114" 
        href="/images/Favicon_114x114.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="120x120" 
        href="/images/Favicon_120x120.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="128x128" 
        href="/images/Favicon_128x128.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="144x144" 
        href="/images/Favicon_144x144.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="150x150" 
        href="/images/Favicon_150x150.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="196x196" 
        href="/images/Favicon_196x196.svg"
      /> 
      <link 
        rel="icon" 
        type="image/png" 
        sizes="310x310" 
        href="/images/Favicon_310x310.svg"
      /> 
      <link 
        rel="manifest" 
        href="/images/site.webmanifest"
      /> 
      <meta name="msapplication-config" content="/images/browserconfig.xml" /> 
      <meta name="msapplication-TileColor" content="#05121D"/> 
      <meta name="theme-color" content="#05121D"></meta>
      <body className="bg-black" />

      {/* Start of HubSpot Embed Code */}
      <script 
        type="text/javascript" 
        id="hs-script-loader" async defer 
        src="//js.hs-scripts.com/6156803.js">
      </script>
      {/*  End of HubSpot Embed Code /}
      {/* Google tag (gtag.js) */}
      {/*<script async src="https://www.googletagmanager.com/gtag/js?id=GTM-TW75PJZ"></script>
      <script src={withPrefix('tagscript.js')} type="text/javascript" />*/}
    </Helmet>
  )
}

export default  Seo;